/* defines data structure for connector (small text) nodes */

import Node from './node';

/**
 * represents a small connector txt-based node
 */
export default class ConnectorNode extends Node {
    /**
     * makes a new connector node given an id and a textcontent
     * @param {number} id
     * @param {string} text
     */
    constructor(id, text) {
        super(id, () => {});
        this.type = 'connector';
        this.setText(text);
        console.log(`new node model ${this.id} of type ${this.type}`);
    }

    /**
     * sets the text of this node
     * 
     * @param {string} newText 
     */
    setText(newText) {
        this.text = newText;
        return this;
    }

    /**
     * no data
     */
    getNewNodeData() {
        // do nothing
    }

    /**
     * no metadata
     */
    get metadata() {
        return '';
    }

    /**
     * gets the title of this node 
     */
    get title() {
        return this.text;
    }

    /**
     * checks if this node is empty
     */
    isEmpty() {
        return false;
    }
}
